import React, { useEffect, useLayoutEffect, useRef } from 'react';
import { useFormikContext } from 'formik';
import {
  InputText,
  InputPassword,
  NumericSelect,
} from '../../../formikBindings';
import {
  FormGroup,
  ButtonContainer,
  SubmitButton,
  SelectOptions,
  SectionHeading,
  MutedText,
} from '../../../form';
import SiteVisitorTypeList from './siteVisitorTypes';
import { ISiteFormProps, ISiteFormValues } from './types';

const SiteForm: React.FC<ISiteFormProps> = ({
  createMode,
  themes,
  visitorTypes,
  questionnaires,
  agreements,
}) => {
  const pinElement = useRef<HTMLInputElement>(null);
  const nameElement = useRef<HTMLInputElement>(null);

  const { values } = useFormikContext<ISiteFormValues>();

  useEffect(() => {}, []);

  useLayoutEffect(() => {
    if (createMode) {
      pinElement.current?.focus();
    } else {
      nameElement.current?.focus();
    }
  }, [createMode]);

  return (
    <>
      <FormGroup name="pin" label="PIN" required={createMode}>
        <InputText
          ref={pinElement}
          name="pin"
          maxLength={4}
          disabled={!createMode}
        />
      </FormGroup>
      <FormGroup name="name" label="Name" required>
        <InputText ref={nameElement} name="name" maxLength={255} />
      </FormGroup>
      {createMode && (
        <FormGroup name="password" label="Password" required>
          <InputPassword name="password" autoComplete="new-password" />
        </FormGroup>
      )}
      <FormGroup name="fireListIdentifier" label="Fire List Identifier">
        <InputText name="fireListIdentifier" maxLength={10} />
      </FormGroup>
      <FormGroup name="emailAddress" label="Email Address">
        <InputText name="emailAddress" maxLength={256} />
        <MutedText>Notified when a visitor arrives</MutedText>
      </FormGroup>
      <FormGroup name="themeId" label="Theme" required>
        <NumericSelect name="themeId">
          <option />
          <SelectOptions options={themes} />
        </NumericSelect>
      </FormGroup>
      <SectionHeading>Visitor Types</SectionHeading>
      <SiteVisitorTypeList
        items={values.visitorTypes}
        visitorTypes={visitorTypes}
        agreements={agreements}
        questionnaires={questionnaires}
      />
      <MutedText>
        Visitor Types will be displayed to the user in the order they appear in this list, the first Visitor Type will be the default
      </MutedText>
      <ButtonContainer>
        <SubmitButton>Save</SubmitButton>
      </ButtonContainer>
    </>
  );
};

export default SiteForm;
